<div
  *ngIf="item"
  [class.active]="selectedId === item.support_id"
  class="contacting"
>
  <div
    [class.process]="item.status === 'IN_PROCESS'"
    [class.new]="item.status === 'NEW'"
    [class.reviewed]="item.status === 'REVIEWED'"
    class="contacting__status"
  >
    <span *ngIf="item.status === 'IN_PROCESS'" class="contacting__status-name">
      {{ "SUPPORT_PAGE.IN_PROCESS" | translate }}
    </span>
    <span *ngIf="item.status === 'NEW'" class="contacting__status-name">
      {{ "SUPPORT_PAGE.NEW" | translate }}
    </span>
    <span *ngIf="item.status === 'REVIEWED'" class="contacting__status-name">
      {{ "SUPPORT_PAGE.REVIEWED" | translate }}
    </span>
  </div>
  <h2 class="contacting__headline">
    {{ "SUPPORT_PAGE.ID_NUMBER" | translate }}: {{ item.support_id }}
  </h2>
  <h3 class="contacting__subtitle">
    {{ "SUPPORT_PAGE." + item.support_type | translate }}
  </h3>
  <div class="contacting__detail">
    <p class="contacting__detail-left">
      {{ "SUPPORT_PAGE.USER" | translate }}
    </p>
    <p class="contacting__detail-right">
      {{ item.full_name }}
    </p>
  </div>
  <div class="contacting__detail">
    <p class="contacting__detail-left">
      {{ "SUPPORT_PAGE.DATE" | translate }}
    </p>
    <p class="contacting__detail-right">
      {{ item.date }}
    </p>
  </div>
</div>
